import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aacc8c84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title gordita-400-12 text-Text/text_medium" }


import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';

type Props = {
  title: string;
  iconClass: string;
  valueClass?: string;
  total: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-summary-error-item',
  props: {
    title: null,
    iconClass: null,
    valueClass: null,
    total: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-summary-error-item gap-2 flex flex-row items-center mr-4" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["circle rounded-full w-2 h-2", __props.iconClass])
      }, null, 2),
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["value gordita-400-12 text-Text/text_high", __props.valueClass])
      }, _toDisplayString(__props.total), 3)
    ]),
    _: 1
  }))
}
}

})